import { combineReducers } from 'redux';

import incomeFromTheUsReducer from './IncomeFromTheUS/slice';
import incomeOutsideOfTheUsReducer from './IncomeOutsideOfTheUS/slice';
import generalReducer from './General/slice';

export default combineReducers({
  general: generalReducer,
  incomeFromTheUs: incomeFromTheUsReducer,
  incomeOutsideOfTheUs: incomeOutsideOfTheUsReducer,
});
